import HeaderWellGuardian from 'components/HeaderWellGuardian';
import Sidebar from 'components/Sidebar';
import { FC, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateSideBarOpen } from '../../redux/WellGuardian';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelectSideBarOpen } from '../../redux/WellGuardian/selectors';

import styles from './Layout.module.scss';
import { useFetchUser } from './useFetchUser';
import { useTrackPage } from './useTrackPage';

export type Props = {
  isMobile?: boolean;
  withMobileWellSelect?: boolean;
  children?: React.ReactNode;
};

const Layout: FC<Props> = ({ isMobile, children }) => {
  const { fetchUser } = useFetchUser();
  const dispatch = useDispatch();
  const isSidebarOpen = useSelectSideBarOpen();
  const isLargeScreen = useMediaQuery('(min-width:1401px)');
  const didSetInitialSidebar = useRef(false);

  useTrackPage();

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  useEffect(() => {
    if (!didSetInitialSidebar.current) {
      const width = typeof window !== 'undefined' ? window.innerWidth : 0;
      const shouldBeOpen = isLargeScreen || width > 1400;
      if (shouldBeOpen && !isSidebarOpen) {
        dispatch(updateSideBarOpen(true));
      } else if (!shouldBeOpen && isSidebarOpen) {
        dispatch(updateSideBarOpen(false));
      }
      didSetInitialSidebar.current = true;
    }
  }, [dispatch, isLargeScreen, isSidebarOpen]);

  const handleDrawerToggle = () => dispatch(updateSideBarOpen(!isSidebarOpen));

  const getComponentToRender = () => {
    return (
      <>
        <HeaderWellGuardian />
        {children}
      </>
    );
  };

  return (
    <div className={styles.container} data-testid="layout">
      {!isMobile && <Sidebar isOpen={isSidebarOpen} onSidebarChanged={handleDrawerToggle} />}
      <div className={styles.content}>{getComponentToRender()}</div>
    </div>
  );
};

export default Layout;
